import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {DomSanitizer} from '@angular/platform-browser';
import {UserBalanceService} from '../../../../layout/user-balance.service';
import {ModalWindowService} from '../../modal-window.service';
import {ModalWindowType} from '../../modal-window-type';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-modal-window-low-balance',
  templateUrl: './modal-window-low-balance.component.html',
})
export class ModalWindowLowBalanceComponent {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor(
    public domSanitizer: DomSanitizer,
    public userBalanceService: UserBalanceService,
    public modalWindowService: ModalWindowService,
    public translateService: TranslateService
  ) {
  }

  openTopUpWindow() {
    this.modalWindowResponse.next({confirmed: true});
    this.modalWindowService.showWindow({
      modalWindowType: ModalWindowType.TopUpBalance,
      title: this.translateService.instant('Top-up of personal account balance'),
      text: this.translateService.instant('Top-up of personal account balance')
    });
  }
  onOkClick() {
    this.modalWindowResponse.next({confirmed: true});
  }
  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }
}
